import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { PermissionsService } from 'app/projects/user/src/lib/services/user-permission.service';

@Injectable()
export class GrowGuard  {
    @Select(UserState.getMyInfo)
    me$: Observable<User>;

    constructor(private _router: Router, private _permissionsService: PermissionsService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.me$.pipe(
            filter((profile) => !!profile),
            map(() => {
                // Check access to the all modules route
                const hasGrowAccess = this._permissionsService.hasAccess('/admin/grow');

                if (hasGrowAccess) {
                    return true; // Allow route activation
                }

                // Find first available route where user has access
                const firstAvailableRoute = this._permissionsService.getFirstAvailableRoute();

                if (firstAvailableRoute) {
                    this._router.navigateByUrl(firstAvailableRoute);
                }

                return false; // Deny activation of this route
            })
        );
    }
}
